import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/shared';
import { tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ConfirmationDialog, ConfirmationService } from '@app/library';
import { Router } from '@angular/router';
import { NguAlertService } from '@app/shared';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {
  // messenger: any;
  constructor(private auth: AuthService, private confirmationService: ConfirmationService, public router: Router, private alert: NguAlertService) { }
  count = 0;
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let paths = '';
    if (req.url.match(/~/)) {
      paths = req.url.replace(/~/, '');
    }
    else {
      // paths = `https://llwrtest.elogistics.com/api/${req.url}`;
      //paths = `https://llwr.cyb.co.uk/api/${req.url}`;
      //paths = `http://10.91.44.23:8081/llwrepository78/public/api/${req.url}`;
      // paths = `http://llwr.agnosticsolutions.com/api/${req.url}`;
      // paths = `https://llwrtest.cyb.co.uk/api/${req.url}`;
      //paths = `http://localhost:8000/api/${req.url}`;
      // paths = `https://llwrdev.cyb.co.uk/api/v2/${req.url}`
        paths = `/api/${req.url}`;
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const headers = req.headers.set(
      'Authorization',
      `Bearer ${this.auth.token}`
    ).append('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0')
      .append('Pragma', 'no-cache')
      .append('Expires', '0');
    // .set('Browser', `${this.auth.getBrowser}`);

    const authReq = req.clone({
      url: paths,
      headers: headers
    });

    if (!['authenticate', 'refreshtoken', 'resetpassword', 'updatepassword'].includes(req.url)) {
      //this.auth.isLoggedIn;
      this.count++;
      if (this.auth.isLoggedIn) {
        // console.log(" logged in valid ");
      } else {
        console.log(" login token expires ", JSON.stringify(this.router.url));
        //redirect to login page - session expires
        if (this.router.url !== '/login') {
          this.alert.open({
            heading: 'Session Expired',
            msg: 'Your session is expired. Please login again',
            type: 'danger'
          });
          this.router.navigate(['/login']);
          return throwError({ error: { message: "unauthorised" } });
        }
      }
    }

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      tap(
        // Succeeds when there is a response; ignore other events
        event => { },
        // Operation failed; error is an HttpErrorResponse
        (error: HttpErrorResponse) => this.auth.handleUnauthorized(error, this.confirmationService)
      )
    );
  }
}
